module.exports = __webpack_public_path__ + "img/JP.8e69fa7d.png";